import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatDate, getTimeGranularity, getTimeGranularityOverview, httpService } from '@flexo/general';


const ENV = (import.meta as any).env;
const LOCALE = navigator.language.split('-')[0] || ENV?.VITE_APP_LOCALE.split('-')[0] || 'en';






export const SetComparisonKpiDataCommunityAsync = createAsyncThunk(
  'kpi/SetComparisonKpiDataCommunityAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet, metadata } = data;


    const [kpiComparisonResponse, ] =
      await Promise.all([
        

        httpService
          .post({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/siteCommunity/comparison/${COMMUNITY_ID}`,
            data: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              timeGranularity: getTimeGranularityOverview(
                selectedTimeSet
              ),
              locale: LOCALE,
              siteId:
                (((metadata?.entities as any)?.site || [])?.filter(
                  (site: any) => site.communityId === COMMUNITY_ID
                ) || []).map((site: any) => site.siteId) || [],
            },
            idToken,
          })
          .then((res: any) => {
            if (res.status === 200) {
              return res.data;
            } else {
              // console.warn({
              //   status: res.status,
              //   message: res.statusText,
              // });
              return null;
            }
          })
          .catch((err: any) => {
            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),
        
      ]);

    return {
      comparison: kpiComparisonResponse,
    }
  }
);

export const SetEnergyKpiDataCommunityAsync = createAsyncThunk(
  'kpi/SetEnergyKpiDataCommunityAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet, metadata } = data;


    const [kpiCommunityOverview, kpiCommunityDetail] =
      await Promise.all([

        httpService
          .get({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/community/energy/${COMMUNITY_ID}`,
            params: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              //add null: null to test the error
              timeGranularity: getTimeGranularityOverview(
                selectedTimeSet
              ),
              locale: LOCALE,
            },
            // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
            idToken,
          })
          .then((res: any) => {

            if (res.status === 200) {
              return res.data;
            } else {
              return null;
            }
          })
          .catch((err: any) => {
            // console.warn(err);

            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),

        // New endpoint request
        httpService
          .get({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/community/energy/${COMMUNITY_ID}`,
            params: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              timeGranularity: getTimeGranularity(
                selectedTimeSet,
                null
              ),
              locale: LOCALE,
            },
            idToken,
          })
          .then((res: any) => {
            if (res.status === 200) {
              return res.data;
            } else {
              // console.warn({
              //   status: res.status,
              //   message: res.statusText,
              // });
              return null;
            }
          })
          .catch((err: any) => {
            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),
      ]);

    return {
      '1day': kpiCommunityOverview,
      '1hour': kpiCommunityDetail,
    }
  }
);

export const SetEnergyCustomKpiDataCommunityAsync = createAsyncThunk(
  'kpi/SetEnergyCustomKpiDataCommunityAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet } = data;
    const [ customKpiCommunityData] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/customKpi/energy/${COMMUNITY_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            aggregationLevel: 'community',
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return customKpiCommunityData

  }
)

export const SetEconomicsCustomKpiDataCommunityAsync = createAsyncThunk(
  'kpi/SetEconomicsCustomKpiDataCommunityAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet } = data;
    const [ customKpiCommunityData] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/customKpi/economics/${COMMUNITY_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            aggregationLevel: 'community',
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return customKpiCommunityData

  }
)

export const SetEconomicsKpiDataCommunityAsync = createAsyncThunk(
  'kpi/SetEconomicsKpiDataCommunityAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet, metadata } = data;


    const [kpiCommunityOverview, kpiCommunityDetail] =
      await Promise.all([

        httpService
          .get({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/community/economics/${COMMUNITY_ID}`,
            params: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              //add null: null to test the error
              timeGranularity: getTimeGranularityOverview(
                selectedTimeSet
              ),
              locale: LOCALE,
            },
            // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
            idToken,
          })
          .then((res: any) => {

            if (res.status === 200) {
              return res.data;
            } else {
              return null;
            }
          })
          .catch((err: any) => {
            // console.warn(err);

            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),



        // New endpoint request
        httpService
          .get({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/community/economics/${COMMUNITY_ID}`,
            params: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              timeGranularity: getTimeGranularity(
                selectedTimeSet,
                null
              ),
              locale: LOCALE,
            },
            idToken,
          })
          .then((res: any) => {
            if (res.status === 200) {
              return res.data;
            } else {
              // console.warn({
              //   status: res.status,
              //   message: res.statusText,
              // });
              return null;
            }
          })
          .catch((err: any) => {
            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),
      ]);

    return {
      '1day': kpiCommunityOverview,
      '1hour': kpiCommunityDetail,
      isLoading: false,
    }
  }
);

export const SetAncillaryKpiDataCommunityAsync = createAsyncThunk(
  'kpi/SetAncillaryKpiDataCommunityAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet, metadata } = data;


    const [kpiCommunityOverview, kpiCommunityDetail] =
      await Promise.all([

        httpService
          .get({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/community/ancillary/${COMMUNITY_ID}`,
            params: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              //add null: null to test the error
              timeGranularity: getTimeGranularityOverview(
                selectedTimeSet
              ),
              locale: LOCALE,
            },
            // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
            idToken,
          })
          .then((res: any) => {

            if (res.status === 200) {
              return res.data;
            } else {
              return null;
            }
          })
          .catch((err: any) => {
            // console.warn(err);

            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),



        // New endpoint request
        httpService
          .get({
            url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/community/ancillary/${COMMUNITY_ID}`,
            params: {
              dateFrom: formatDate(selectedDate[0]),
              dateTo: formatDate(selectedDate[1]),
              timeGranularity: getTimeGranularity(
                selectedTimeSet,
                null
              ),
              locale: LOCALE,
            },
            idToken,
          })
          .then((res: any) => {
            if (res.status === 200) {
              return res.data;
            } else {
              // console.warn({
              //   status: res.status,
              //   message: res.statusText,
              // });
              return null;
            }
          })
          .catch((err: any) => {
            // setAlertStore({
            //   type: AlertTypes.SetAlert,
            //   payload: {
            //     value: {
            //       type: 'BANNER_UNEXPECTED_ERROR',
            //     },
            //   },
            // });

            return null;
          }),
      ]);

    return {
      '1day': kpiCommunityOverview,
      '1hour': kpiCommunityDetail,
    }
  }
);

export const SetEnergyKpiDataSiteAsync = createAsyncThunk(
  'kpi/SetEnergyKpiDataSiteAsync',
  async function (data: any) {

    const { SITE_ID, idToken, selectedDate, selectedTimeSet } = data;

    const [kpiSiteDataOverview, kpiSiteDataDetail] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/energy/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),

      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/energy/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularity(
              selectedTimeSet,
              null
            ),
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return {
      '1day': kpiSiteDataOverview,
      '1hour': kpiSiteDataDetail,
    }

  }
)

export const SetAncillaryKpiDataSiteAsync = createAsyncThunk(
  'kpi/SetAncillaryKpiDataSiteAsync',
  async function (data: any) {

    const { SITE_ID, idToken, selectedDate, selectedTimeSet } = data;

    const [kpiSiteDataOverview, kpiSiteDataDetail] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/ancillary/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),

      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/ancillary/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularity(
              selectedTimeSet,
              null
            ),
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return {
      '1day': kpiSiteDataOverview,
      '1hour': kpiSiteDataDetail,
    }

  }
)

export const SetEconomicsKpiDataSiteAsync = createAsyncThunk(
  'kpi/SetEconomicsKpiDataSiteAsync',
  async function (data: any) {

    const { SITE_ID, idToken, selectedDate, selectedTimeSet } = data;

    const [kpiSiteDataOverview, kpiSiteDataDetail] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/economics/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),

      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/economics/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularity(
              selectedTimeSet,
              null
            ),
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return {
      '1day': kpiSiteDataOverview,
      '1hour': kpiSiteDataDetail,
    }

  }
)

export const SetEconomicsCustomKpiDataSiteAsync = createAsyncThunk(
  'kpi/SetEconomicsCustomKpiDataSiteAsync',
  async function (data: any) {

    const { SITE_ID, idToken, selectedDate, selectedTimeSet } = data;
    const [ customKpiSiteData] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/customKpi/economics/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            aggregationLevel: 'site',
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return customKpiSiteData

  }
)

export const SetEnergyKpiDataMemberAsync = createAsyncThunk(
  'kpi/SetEnergyKpiDataMemberAsync',
  async function (data: any) {

    const { sites, idToken, selectedDate, selectedTimeSet } = data;
    const [kpiMemberDataOverview, kpiMemberDataDetail] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/energy/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            siteId: sites,
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),

      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/energy/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularity(
              selectedTimeSet,
              null
            ),
            siteId: sites,
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return {
      '1day': kpiMemberDataOverview,
      '1hour': kpiMemberDataDetail,
    }

  }
)



export const SetEnergyCustomKpiDataSiteAsync = createAsyncThunk(
  'kpi/SetEnergyCustomKpiDataSiteAsync',
  async function (data: any) {

    const { SITE_ID, idToken, selectedDate, selectedTimeSet } = data;
    const [ customKpiSiteData] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/customKpi/energy/${SITE_ID}`,
          params: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            aggregationLevel: 'site',
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return customKpiSiteData

  }
)


export const SetEnergyCustomKpiDataMemberAsync = createAsyncThunk(
  'kpi/SetEnergyCustomKpiDataMemberAsync',
  async function (data: any) {

    const { sites, idToken, selectedDate, selectedTimeSet } = data;
    const [ customKpiMemberData] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v2_0/site/custom/energy/grouped`,
          
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            siteId: sites,
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            aggregationLevel: 'member',
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return customKpiMemberData

  }
)

export const SetAncillaryKpiDataMemberAsync = createAsyncThunk(
  'kpi/SetAncillaryKpiDataMemberAsync',
  async function (data: any) {

    const { sites, idToken, selectedDate, selectedTimeSet } = data;
    const [kpiMemberDataOverview, kpiMemberDataDetail] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/ancillary/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            siteId: sites,
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),

      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/ancillary/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularity(
              selectedTimeSet,
              null
            ),
            siteId: sites,
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return {
      '1day': kpiMemberDataOverview,
      '1hour': kpiMemberDataDetail,
    }

  }
)

export const SetEconomicsKpiDataMemberAsync = createAsyncThunk(
  'kpi/SetEconomicsKpiDataMemberAsync',
  async function (data: any) {

    const { sites, idToken, selectedDate, selectedTimeSet } = data;
    const [kpiMemberDataOverview, kpiMemberDataDetail] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/economics/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            siteId: sites,
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),

      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/economics/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularity(
              selectedTimeSet,
              null
            ),
            siteId: sites,
            locale: LOCALE,
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return {
      '1day': kpiMemberDataOverview,
      '1hour': kpiMemberDataDetail,
    }

  }
)

export const SetEconomicsCustomKpiDataMemberAsync = createAsyncThunk(
  'kpi/SetEconomicsCustomKpiDataMemberAsync',
  async function (data: any) {

    const { sites, idToken, selectedDate, selectedTimeSet } = data;
    const [ customKpiMemberData] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/site/custom/economics/grouped`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            siteId: sites,
            //add null: null to test the error
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            aggregationLevel: 'member',
          },
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR',
          //     },
          //   },
          // });

          return null;
        }),
    ]);

    return customKpiMemberData

  }
)

export const SetEnergyKpiDataCommunityRankingAsync = createAsyncThunk(
  'kpi/SetEnergyKpiDataCommunityRankingAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet } = data;

    const [energyRanking,] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/siteCommunity/energy/ranking/${COMMUNITY_ID}`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
            kpiLists: [
              ['self_consumption_direct',
              'self_consumption_battery',
              'from_shared',
                'from_grid',],
              [
                'self_consumption_direct',
              'production_to_battery',
              'to_shared',
              'to_grid',
              ]
            ],
            rankingKpis: [
              'consumption',
              'production',
            ],
          },
          // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            throw new Error(res.statusText);
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);
            throw new Error(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR'
          //     },
          //   }
          // })

          return null;
        }),

    ]);

    return {
      energyRanking: energyRanking || [],
    }

  }
)
export const SetEconomicsKpiDataCommunityRankingAsync = createAsyncThunk(
  'kpi/SetEconomicsKpiDataCommunityRankingAsync',
  async function (data: any) {

    const { COMMUNITY_ID, idToken, selectedDate, selectedTimeSet } = data;

    const [economicsRanking] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/siteCommunity/economics/ranking/${COMMUNITY_ID}`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
            rankingKpis: ['total_benefits'],
            kpiLists: [['revenues', 'savings']]
          },
          // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            throw new Error(res.statusText);
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);
            throw new Error(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR'
          //     },
          //   }
          // })

          return null;
        }),
      

    ]);

    return {
      economicsRanking: economicsRanking || [],
    }

  }
)

export const SetEnergyKpiDataMemberRankingAsync = createAsyncThunk(
  'kpi/SetEnergyKpiDataMemberRankingAsync',
  async function (data: any) {

    const { MEMBER_ID, idToken, selectedDate, selectedTimeSet } = data;



    const [energyRanking] = await Promise.all([
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/siteMember/energy/ranking/${MEMBER_ID}`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
            kpiLists: [[
              'self_consumption_direct',
              'self_consumption_battery',
              'from_shared',
              'from_grid',
            ],
            [
              'self_consumption_direct',
              'production_to_battery',
              'to_shared',
              'to_grid',
              ],
            ],
            rankingKpis: [
              'consumption',
              'production',
            ]
          },
          // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR'
          //     },
          //   }
          // })

          return null;
        })

    ]);

    return {
      energyRanking: energyRanking || [],
    }

  }
)

export const SetEconomicsKpiDataMemberRankingAsync = createAsyncThunk(
  'kpi/SetEconomicsKpiDataMemberRankingAsync',
  async function (data: any) {

    const { MEMBER_ID, idToken, selectedDate, selectedTimeSet } = data;



    const [economicsRanking] = await Promise.all([
      
      httpService
        .post({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/kpi/v2_0/siteMember/economics/ranking/${MEMBER_ID}`,
          data: {
            dateFrom: formatDate(selectedDate[0]),
            dateTo: formatDate(selectedDate[1]),
            timeGranularity: getTimeGranularityOverview(
              selectedTimeSet
            ),
            locale: LOCALE,
            rankingKpis: ['total_benefits'],
            kpiLists: [['revenues', 'savings']]
          },
          // ${ENV.VITE_APP_BASE_URL}//hive/api/kpi/v1_2/community/${metaDataApiStore.selectedEntityId}
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText,
            // });
            return null;
          }
        })
        .catch((err: any) => {
          // console.warn(err);

          // setAlertStore({
          //   type: AlertTypes.SetAlert,
          //   payload: {
          //     value: {
          //       type: 'BANNER_UNEXPECTED_ERROR'
          //     },
          //   }
          // })

          return null;
        }),

    ]);

    return {
      economicsRanking: economicsRanking || [],
    }

  }
)
